export function formatDate(rawDate) {
  const date = new Date(rawDate);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2); // '25'

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  //return `${month}/${day}/${year} ${hours}:${minutes}${ampm}`;
  return `${month}/${day}/${year}`;
}
